import AutoCompleteStockTransferSettingCard from './autoCompleteStockTransferSettingCard.container';

export default AutoCompleteStockTransferSettingCard;